module.exports = __webpack_public_path__ + "img/87f28fd58cc4c94edf07c50ccb9aeee7.png";